module.exports = __webpack_public_path__ + "dbe5f4ac431bae587e94dbf1b9d0ecfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-320.jpg
// module id = 454
// module chunks = 0